/**
 * Switch to selected page.
 */
function goto_search(){
    if(!!document.querySelector('.search-input-btn')){
        const searchButton = document.querySelector(".search-input-btn");
        const searchInput = document.querySelector('#search-input-text');

        function search(event) {
            event.preventDefault();
            const searchTerm = searchInput.value;
            const encodedSearchTerm = encodeURIComponent(searchTerm);

            const newUrl = `${searchButton.href}?q=${encodedSearchTerm}`.replace(/\/\?/, "?");

            searchButton.href = newUrl;
            window.location.href = newUrl;
        }
    

        if (searchButton && searchInput) {
            searchButton.addEventListener('click', (e) => {
                search(e);
            });
    
            searchInput.addEventListener('keypress', (e) => {
                if (e.key === "Enter") {
                    search(e);
                }
            })
        }
    }
}

goto_search();

export default goto_search;